export interface DynamicUrlParams {
  firmSlug?: string;
  companySlug?: string;
  measurementDate?: string;
  version?: string;
  additionalParams?: Record<string, string>;
}

export interface PdfPage {
  url: string;
  title: PdfExportPageTitles;
  exportTarget: PdfExportTarget;
  exportTab?: string;
}

export enum PdfExportPageTitles {
  VALUATION_SUMMARY = 'Valuation Summary',
  EQUITY_ALLOCATION = 'Equity Allocation',
  CONCLUDED_SHARE_VALUES = 'Concluded Share Values',
  FINANCIALS = 'Financials',
  CAP_TABLE = 'Cap Table',
  FUND_OWNERSHIP = 'Fund Ownership',
  BREAKPOINT_ANALYSIS = 'Breakpoints',
  BACKSOLVE = 'Backsolve',
  FUND_SUMMARY = 'Fund Summary',
  SCHEDULE_OF_INVESTMENTS = 'Schedule of Investments',
  FIRM_SUMMARY = 'Firm Summary',
}

export enum PdfExportTarget {
  VALUATION_SUMMARY_TABLE = 'valuationSummaryTable',
  VALUATION_EQUITY_ALLOCATION_TABLE = 'valuationEquityAllocationTable',
  VALUATION_CONCLUDED_SHARE_VALUES_TABLE = 'valuationConcludedShareValuesTable',
  FINANCIALS_TABLES = 'financialsTables',
  CAP_TABLE = 'capTable',
  FUND_OWNERSHIP_TABLE = 'fundOwnershipTable',
  BREAKPOINTS_TABLE = 'breakpointsTable',
  BACKSOLVE_TABLES = 'backsolveTables',
  FUND_SUMMARY_TABLE = 'fundSummaryTable',
  FUND_SCHEDULE_OF_INVESTMENTS_TABLES = 'scheduleOfInvestmentsTables',
  FIRM_SUMMARY_TABLE = 'firmSummaryTable',
}

export interface PdfExportSupportedQueryParams {
  date?: string | null;
  version?: string | null;
  exportMode?: string | null;
  exportTarget?: string | null;
  exportTab?: string | null;
}
